import { GetInvoiceDetailResponseItemDto } from '@ekt-group/general-purpose-api-interfaces';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { fetchFn, QueryConfig } from '@/lib/react-query';

const getInvoiceDetails = (invoiceNo: string): Promise<GetInvoiceDetailResponseItemDto[]> => {
  return fetchFn(`/invoices/${invoiceNo}/`);
};

export const getInvoiceDetailsQueryOptions = (invoiceNo: string) => {
  return queryOptions({
    queryKey: ['invoice-details', { invoiceNo }],
    queryFn: () => getInvoiceDetails(invoiceNo),
  });
};

type UseInvoiceDetailsOptions = {
  params: { invoiceNo: string };
  queryConfig?: QueryConfig<typeof getInvoiceDetailsQueryOptions>;
};

export const useGetInvoiceDetails = ({ params, queryConfig }: UseInvoiceDetailsOptions) => {
  return useQuery({
    ...getInvoiceDetailsQueryOptions(params.invoiceNo),
    ...queryConfig,
  });
};
